import { createSvgIcon } from '@mui/material/utils';
import React from 'react';

export const UiWebpageCursor = createSvgIcon(
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 6H16"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M8 10H16"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M8 14H11"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M2 4H1V16H2"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 0C4.44772 0 4 0.447715 4 1V19C4 19.5523 4.44772 20 5 20H14.556L13.8893 18H6V2H18V13.899L20 14.5657V1C20 0.447715 19.5523 0 19 0H5ZM22 15.2323L24 15.899V4C24 3.44772 23.5523 3 23 3H22V4V5V15V15.2323ZM24 18L15 15L18 24L20 20L24 18Z"
      fill="currentColor"
    />
  </svg>,
  'UiWebpageCursor'
);
